(function() {
'use strict';
angular.module('dnSecurity')
.provider('secSecurityService', function() {
  this.authorityPrefix = 'AUTHORITY_';
  this.requiredAuthorities = [];
  var self = this;
  this.$get = ['secPortalUserResource', 'secLogoutResource', '$q', '$rootScope', '$http',
    function(portalUserResource, logoutResource, $q, $rootScope, $http) {
      let promise;
      var securityService = {
        getLoggedInUser: getLoggedInUser,
        logout: logout,
        ensureActiveSession: ensureActiveSession,
        hasAllAuthorities: hasAllAuthorities,
        hasAuthority: hasAllAuthorities,
        hasAuthorities: hasAllAuthorities,
        hasAnyAuthority: hasAnyAuthority,
        getAuthorities: getAuthorities,
        notGrantedAuthorities: notGrantedAuthorities,
        clearAuthentication: clearAuthentication,
        switchUser: switchUser,
        exitSwitchUser: exitSwitchUser,
        getAuthenticationErrorMessage: getAuthenticationErrorMessage,
        getUserHome: getUserHome
      };

      function getUserHome() {
        return getAuthorities().then(function(authorities) {
          if (_.intersection(authorities, ['USER_ADMIN', 'USER_SUPER_ADMIN']).length) {
            return 'admin.users';
          } else if (authorities.indexOf('DSO_ADMIN_USER') >= 0) {
            return 'dsoAdmin.users';
          } else if (authorities.indexOf('PROVIDER_USER') >= 0) {
            return 'lookup';
          }
        });
      }

      function ensureActiveSession() {
        return $http.get('protected');
      }

      let authErrors = {
        'Bad credentials' : {
          login: 'You have entered an invalid User ID or Password.',
          switchUser: 'The User ID is invalid.'
        },
        'User with unverified email' : {
          login: 'You can not login until you verify your email address.',
          switchUser: 'The user\'s email address has not been verified.'
        },
        'User is disabled': {
          login: 'Your account has been disabled. Please call us  at 855-260-3453.',
          switchUser: 'The account has been disabled.'
        },
        'User account is locked' : {
          login: 'Your account has been Locked. Please call us  at 855-260-3453.',
          switchUser: 'The account has been locked.'
        }
      };

      function getAuthenticationErrorMessage(code, switchUser) {
        let type = switchUser ? 'switchUser' : 'login';
        if (authErrors[code] && (authErrors[code][type] || authErrors[code].login)) {
          return authErrors[code][type] || authErrors[code].login;
        }
        return code;
      }

      function switchUser(userId) {
        return $http.post('login/impersonate?username=fdl.dpp.' + userId).then(function(result) {
          if (result.data.authentication) {
            clearAuthentication();
          }
          return result.data;
        });
      }

      function exitSwitchUser() {
        return $http.post('logout/impersonate').then(function() {
          clearAuthentication();
          return getLoggedInUser();
        });
      }
      function clearAuthentication() {
        promise = undefined;
      }
      function getLoggedInUser() {
        if(!promise) {
          promise = portalUserResource.get().$promise.then((data) => {
            // Handles page refresh and first time user login.
              return data;
          });
        }
        return promise;
      }

      function logout() {
        return logoutResource.get().$promise.then(() => {
          promise = null;
        });
      }

      function hasAllAuthorities(auths) {
        if (!auths) {
          auths = [];
        }
        auths = angular.isArray(auths) ? auths : [auths];
        auths = _.union(auths, self.requiredAuthorities);
        //If the intersection of the two sets is the size of auths, return true
        return getAuthorities().then((granted) =>  _.intersection(granted, auths).length === auths.length);
      }

      function notGrantedAuthorities(auths) {
        //If the intersection of the two sets has elements, reurn false
        return getAuthorities().then((granted) => !_.intersection(granted, auths).length);
      }


      function hasAnyAuthority(auths) {
        if (!auths) {
          auths = [];
        }
        auths = angular.isArray(auths) ? auths : [auths];
        let promises = [];
        if (auths.length) {
          //If the intersection of the two sets has elements, return true
          promises.push(getAuthorities().then((granted) => !!_.intersection(granted, auths).length));
        }
        if (self.requiredAuthorities.length) {
          promises.push(hasAllAuthorities());
        }
        if (promises.length) {
          return $q.all(promises).then((res) => {
            //Look for falses, if we find one, return false
            return _.find(res, (val) => !val) !== false;
          });
        } else {
          return $q.resolve(true);
        }
      }

      function getAuthorities() {
        return securityService.getLoggedInUser().then((res) => {
          return _.map(res.authorities, (auth) => {
            if (!self.authorityPrefix || auth.authority.indexOf(self.authorityPrefix) !== 0) {
              return auth.authority;
            }
            return auth.authority.substring(self.authorityPrefix.length);
          });
        });
      }
      return securityService;
    }];
});
})();
